import LanguageLocaleUtils from 'utils/LanguageLocale';

function roundToFirstButIgnoreZeroes(num, locale = 'en-US') {
    return num.toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        useGrouping: false
    });
}

const REVIEW_COUNT_ABBREVIATION_THRESHOLD = 999;

function isReviewCountAbbreviated(count) {
    return count > REVIEW_COUNT_ABBREVIATION_THRESHOLD;
}

function formatReviewCount(count) {
    const locale = LanguageLocaleUtils.getCurrentLanguageLocale();

    if (count > 999999) {
        return roundToFirstButIgnoreZeroes(count / 1000000, locale) + 'M';
    } else if (isReviewCountAbbreviated(count)) {
        return roundToFirstButIgnoreZeroes(count / 1000, locale) + 'K';
    } else {
        return count;
    }
}

export default { formatReviewCount, isReviewCountAbbreviated };
